import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";


export const getSuppliers = catchAsync(async () => {
  const { data } = await axiosInstance.get(`salon/suppliers`);
  return data;
});
export const showSuppliers = catchAsync(async (id, xTranslations) => {
  const { data } = await axiosInstance.get(`salon/suppliers/${id}`, {
    headers: {
      "x-translations": xTranslations,
    },
  });
  return data;
});
export const updateSuppliers = catchAsync(async (body) => {
  console.log("Sending payload:", body);
  const { data } = await axiosInstance.put(`salon/suppliers/${body?.id}`, body);
  return data;
});
export const deleteSuppliers = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(`salon/suppliers/${id}`);
  return data;
});
